$(function () {
    // 图片数组
    var imgArray = [];

    function getUrlParam(name) {
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null;
    }

    var coincode = getUrlParam('id');
    var score = getUrlParam('score');
    var type = getUrlParam('type');
    score = decodeURIComponent(score);
    if (score == '真品') {
        score = 0;
    }

    $(document).on('click', '.tooltip-help', function () {
        $('.tooltip-toggle').hide();
        if ($(this).find('.tooltip-toggle').length > 0) {
            $(this).find('.tooltip-toggle').show();
        } else {
            var title = $(this).attr('data-title');
            var toggleRight = $(this).attr('data-direction') || '';
            $(this).append('<span class="tooltip-toggle' + (toggleRight == 'right' ? ' tooltip-right' : '') + '">' + title + '</span>');
        }
    });
    $(document).on('click', function (e) {
        if (!$(e.target).parent().hasClass('tooltip-help')) {
            $('.tooltip-toggle').hide();
        }
    });

    $.ajax({
        url: doMain + (type == 'app' ? '' : 'h5/') + 'feature/provide.shtml?coincode=' + coincode + '&score=' + score,
        dataType: 'json',
        type: 'post',
        success: function (result) {
            $('.five').html('');
            if (result.result == "nothing") {
                $(".jiange").html("未找到符合条件的藏品信息！").show();
            } else {
                p1 = result.pictrues.pathA ? result.pictrues.pathA.replace(/http/, "https").replace(/www/, "home") : '';
                p2 = result.pictrues.pathB ? result.pictrues.pathB.replace(/http/, "https").replace(/www/, "home") : '';
                imgArray.push(p1);
                imgArray.push(p2);
                $('.tu1').attr('src', p1);
                $('.tu2').attr('src', p2);

                var zhujie = '', isEn = result.baseVo && result.baseVo.langType == 2, isRecall = result.isRecall;
                var onlineHtml = window.location.hostname == 'ft1.h5.zhaoonline.com' ? '.html' : '';

                if (isEn) {
                    $('.title h1').html('Item Details');
                }

                if (result.type == '6') {
                    $('.shuoming').show();

                    $('.five').append(`<p><span>评分明细</span><span data-type="评分"></span></p>`);
                    var str = '<div style="background-color:#dfdbdb;">';
                    $(result.seriesList).each(function (idx, item) {
                        str += '<div class="yiban" style="background-color:transparent;"><span style="font-size:14px;">' + item.name + '</span><span style="font-size:15px;" data-type="' + idx + '">' + item.score + '</span></div>';
                    });
                    str += '</div>';
                    $('.five').append(str);
                    $(result.tables).each(function (i, item) {
                        if (item.zhName == '注解') {
                            zhujie = item.zhValue
                        }
                        if (item.zhName != '评分' && item.zhName != '注解') {
                            if (item.zhValue) {
                                if (item.zhName != '目录编号' && item.zhName != '详细名称') {
                                    $('.five').append(`<p><span>${item.zhName}</span><span data-type=${item.zhName}>${item.zhValue}</span></p>`)
                                }
                            } else {
                                if (item.zhName != '目录编号' && item.zhName != '详细名称') {
                                    $('.five').append(`<p><span>${item.zhName}</span><span data-type=${item.zhName}></span></p>`)
                                }

                            }
                        }
                    });

                } else {
                    $('.shuoming').hide();
                    $(result.tables).each(function (i, item) {
                        if (item.zhValue && item.zhName != '注解' && item.zhName != '源流') {
                            $('.five').append(`<p><span>${item.zhName}</span><span data-type=${item.zhName}>${item.zhValue}</span></p>`)
                        }
                        if (!item.zhValue && item.zhName != '注解' && item.zhName != '源流') {
                            $('.five').append(`<p><span>${item.zhName}</span><span data-type=${item.zhName}></span></p>`)
                        }
                        if (item.zhName == '注解') {
                            zhujie = item.zhValue
                        }
                    });
                }
                if (result.isGoldLabel == 'Y') {
                    zhujie = result.baseVo.annotation;
                    result.baseVo.totalNum = result.baseVo.totalNum || 0;
                    result.baseVo.count = result.baseVo.count || 0;
                    var featureKey = result.baseVo.featureKey
                    if (result.baseVo.fullSubject.indexOf('首日封') != -1) {
                        featureKey = ''
                    }
                    if (result.baseVo.fullSubject.indexOf('明信片') != -1 && result.baseVo.featureKey.indexOf('新票') != -1) {
                        featureKey = '新';
                    }
                    if (result.baseVo.fullSubject.indexOf('明信片') != -1 && result.baseVo.featureKey.indexOf('旧票') != -1) {
                        featureKey = '旧';
                    }
                    if (result.baseVo.fullSubject.indexOf('邮简') != -1 && result.baseVo.featureKey.indexOf('新票') != -1) {
                        featureKey = '新简';
                    }
                    if (result.baseVo.fullSubject.indexOf('邮简') != -1 && result.baseVo.featureKey.indexOf('旧票') != -1) {
                        featureKey = '旧简';
                    }
                    var featureNum = result.baseVo.features ? result.baseVo.features.match(/(?:Mint.*?)(?:Sheet\s+of\s+(\d+))/) : '';
                    if (featureNum) {
                        featureNum = featureNum[1]
                    }
                    if (featureKey && isRecall != 'Y') {
                        $('.five').append(`<p><span>${isEn?'Features':'特性'}</span><span data-type="${isEn?'Features':'特性'}">${isEn ? (result.baseVo.featureKey == '新票' ? 'Mint' : 'Mint' + (featureNum ? ' Sheet of ' + featureNum : '')) : featureKey}</span></p>`);
                    }
                    if (isRecall != 'Y') {
                        $('.five').append(`<p><span>${isEn ? 'Grade' : '评分'}</span><span data-type="${isEn ? 'Grade' : '评分'}">${result.baseVo.gradescore}</span></p>`);
                    }
                    var numStr = '0'
                    if (result.baseVo.num > 0) {
                        if (result.baseVo.featureKey == '新票整版') {
                            numStr = '<a href="./statistics' + onlineHtml + '?s=2&code=' + coincode + (isEn ? '&lang=en' : '') + (isEn ? '&features=' + (result.baseVo.featureKey == '新票' ? 'Mint' : 'Mint' + (featureNum ? ' Sheet of ' + featureNum : '')) : '&features=' + featureKey) + '" class="link">' + result.baseVo.num + '</a>';
                        } else {
                            numStr = '' + result.baseVo.num;
                        }
                    }
                    if (isRecall != 'Y') {
                        $('.five').append('<p><span>' + (isEn ? 'Quantity' : '数量') + '<span class="tooltip-help" data-title="' + (isEn ? 'Gold Label Count at Current Score' : '当前分数金标评级数') + '"><img src="./img/icon-help.png" alt="" class="img-help"></span></span><span data-type="' + (isEn ? 'Quantity' : '数量') + '">' + numStr + '</span></p>');
                    }
                    var highNumStr = '0';
                    if (result.baseVo.highNum > 0) {
                        if (result.baseVo.featureKey == '新票' || result.baseVo.featureKey == '盖销' || result.baseVo.featureKey == '信销' || result.baseVo.featureKey == '旧票') {
                            highNumStr = '<a href="./statistics' + onlineHtml + '?s=1&code=' + coincode + (isEn ? '&lang=en' : '') + (isEn ? '&features=' + (result.baseVo.featureKey == '新票' ? 'Mint' : 'Mint' + (featureNum ? ' Sheet of ' + featureNum : '')) : '&features=' + featureKey) +  '" class="link">' + result.baseVo.highNum + '</a>'
                        } else if (result.baseVo.featureKey == '新票整版') {
                            highNumStr = '<a href="./statistics' + onlineHtml + '?s=3&code=' + coincode + (isEn ? '&lang=en' : '') + (isEn ? '&features=' + (result.baseVo.featureKey == '新票' ? 'Mint' : 'Mint' + (featureNum ? ' Sheet of ' + featureNum : '')) : '&features=' + featureKey) + '" class="link">' + result.baseVo.highNum + '</a>'
                        } else {
                            highNumStr = '' + result.baseVo.highNum;
                        }
                    }
                    if (isRecall != 'Y') {
                        $('.five').append('<p><span>' + (isEn ? 'Count Above' : '高于数量') + '<span class="tooltip-help" data-title="' + (isEn ? 'Gold Label Count Above the Current Score' : '高于当前分数金标评级数') + '"><img src="./img/icon-help.png" alt="" class="img-help"></span></span><span data-type="' + (isEn ? 'Count Above' : '高于数量') + '">' + highNumStr + '</span></p>');
                    }
                    $('.five').append(`<p><span>${isEn?'Total Quantity':'总数量'}<span class="tooltip-help" data-title="${isEn?'Total Quantity For Same Type':'相同特性总数量'}"><img src="./img/icon-help.png" alt="" class="img-help"></span></span><span data-type="${isEn?'Total Quantity':'总数量'}">${result.baseVo.totalNum}（${isEn?'Total':'总计'}：${result.baseVo.count}<span class="tooltip-help" data-direction="right" data-title="${isEn?'Overall Total':'此品种总数量'}"><img src="./img/icon-help.png" alt="" class="img-help"></span>）</span></p>`);
                }
                if (zhujie && isRecall != 'Y') {
                    $('.five').append(`<p><span>${isEn?'Note':'注解'}</span><span data-type="${isEn?'Note':'注解'}" style="text-align:left;">${zhujie}</span></p>`);
                }
                if (coincode == 893515001) {
                    $('.five').append(`<p><span>注解</span><span data-type="注解" style="text-align:left;">目前发现存世最大方连</span></p>`);
                }
                var stampSource = result.baseVo ? (result.baseVo.stampSource || '') : '';
                if (stampSource && isRecall != 'Y') {
                    $('.five').append(`<p><span>${isEn?'Provenance':'源流'}</span><span data-type="${isEn?'Provenance':'源流'}" style="text-align:left;">${stampSource}</span></p>`);
                }
            }
        }
    });

    new Vue({
        el: '#myCarousel',
        methods: {
            previewImg(e) {
                if (window.navigator.userAgent.indexOf('MicroMessenger') > -1) {
                    wx.previewImage({
                        current: e.target.currentSrc,
                        urls: imgArray
                    })
                } else {
                    var customIndex = 0;
                    var currentUrl = e.target.currentSrc;
                    for (var i = 0; i < imgArray.length; i++) {
                        if (currentUrl == imgArray[i]) {
                            customIndex = i;
                        }
                    }
                    this.$createImagePreview({
                        imgs: imgArray,
                        initialIndex: customIndex
                    }).show();
                }
            }
        }
    })
});